import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShareService extends ApiService {

  constructor(http: HttpClient) {
    super(`${environment.apiUrl}`, http);
  }

  getCategory(){
    return this.getUrl('/shared/category');
  }

  getClassification(){
    return this.getUrl('/shared/classification');
  }

  getStatusOpportunity(){
    return this.getUrl('/shared/opportunity/status');
  }

  getProductFamily(){
    return this.getUrl('/shared/product/family');
  }

  getOpportunityPrice(){
    return this.getUrl('/shared/opportunity/price');
  }

  getCountry(){
    return this.getUrl('/shared/country');
  }

  getRegion(id){
    return this.getUrl('/shared/country/'+id+'/region?rel=true');
  }

  getVisitTime() {
    return this.getUrl('/shared/visit/time');
  }

  getVisitType() {
    return this.getUrl('/shared/visit/type');
  }

  getActivityTime() {
    return this.getUrl('/shared/activity/time');
  }

  getActivityType() {
    return this.getUrl('/shared/activity/type');
  }

  getContactClient(id) {
    return this.getUrl('/shared/contact/'+id);
  }

  getQuoteReason() {
    return this.getUrl('/shared/quote/client');
  }

  getQuoteProduct() {
    return this.getUrl('/shared/product');
  }
  
  getPartner() {
    return this.getUrl('/shared/partner');
  }

  getBrickZoneRegion(id) {
    return this.getUrl('/shared/brickZoneRegion/'+id);
  }
}
